import { USER_ROLE } from 'src/data/user';
import { useCustomerMembers } from './useCustomerMembers';

export const useCustomerAdmins = () => {
  const { members } = useCustomerMembers();
  const admins = members.filter((user) => user.role === USER_ROLE.admin);

  return admins;
};
